import {
  inject,
  Injectable,
  NgZone,
  signal
} from '@angular/core';

import { syncWithLocalStorage } from '@core/helpers';

import { BrowserApiService } from '../common';

@Injectable({
  providedIn: 'root'
})
export class SoundsState {
  private readonly ngZone = inject(NgZone);
  private readonly browser = inject(BrowserApiService);

  public readonly volume = signal<number>(0.3);
  public readonly isMuted = signal<boolean>(false);

  private readonly localStorageEffect = syncWithLocalStorage('sounds', {
    volume: this.volume,
    isMuted: this.isMuted
  });

  constructor() {
    if(this.browser.isServer()) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      Howler.volume(this.volume());
      Howler.mute(this.isMuted());
    });
  }

  setVolume(volume: number): void {
    this.volume.set(volume);

    this.ngZone.runOutsideAngular(() => {
      Howler.volume(volume);
      Howler.mute(0 === volume);
    });
  }

  toggleMute(): void {
    this.isMuted.update((value) => !value);

    this.ngZone.runOutsideAngular(() => Howler.mute(this.isMuted()));
  }
}